<template>
  <div class="choose_video2">
    <ul class="choose_video_list">
      <li v-for="video in productMediaData.videoList">
        <div class="result_banner2_img" @click="openVideoPlayer" />
      </li>
    </ul>
  </div>
</template>

<script>
import MyVideo from './video.vue';
export default {
  name: 'ChooseVideo',
  components: {
    MyVideo,
  },
  filters: {},
  mixins: [],
  props: {
    productMediaData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data() {
    return {
      isShowMyVideo: false
    }
  },
  computed: {
  },
  watch: {
    isShowMyVideo (val) {
      this.mediaData.zIndex = val ? 200 : 1
    }
  },
  created() {},
  mounted() {
  },
  methods: {
    openVideoPlayer () {
      if (this.mediaData.videoUrl) {
        this.isShowMyVideo = true
      }
    },
    closeVideoPlayer () {
      this.isShowMyVideo = false
    }
  }
};
</script>

<style>
html {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.choose_video2 {
  position: relative;
  font-size: 0;
  margin-bottom: -23px;
  img {
    width: 100%;
  }
  & .result_banner2_btn {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    /*background: rgba(0,0,0,0.5);*/
    & .result_banner2_btn_icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 42px;
      width: 42px;
      background-image: url(https://media.winbaoxian.com/autoUpload/activity/video-paly_7c9d6828cc20de0.png);
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
    }
  }
  & .player_loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
  }
}
</style>
